import React from "react";
import { Button } from "../../primary";
import PlusIcon from "../../../static/images/plus-icon_white.svg";
import { MultiFileUploadFormBuilder } from "./multiFileUploadFormBuilder";
import styles from "./assign.module.scss";
import type { FormBuilderQuestion, FormBuilderSection, QuestionMedia } from "../../../features/custom-forms";

interface MediaListProps {
  media?: QuestionMedia;
  addMedia?: { index?: number };
  handleAddMedia: (questionIndex: number) => void;
  handleAddMediaCancel: () => void;
  questionId?: number;
  formId?: number;
  questionIndex: number;
  customFormBuilder: FormBuilderQuestion[];
  setcustomFormBuilder: React.Dispatch<React.SetStateAction<FormBuilderQuestion[]>>;
  setSectionInfo: React.Dispatch<React.SetStateAction<FormBuilderSection[]>>;
  dropRef: React.RefObject<HTMLElement>;
}

export const MediaList: React.FC<MediaListProps> = ({
  media,
  addMedia,
  handleAddMedia,
  handleAddMediaCancel,
  questionId,
  formId,
  questionIndex,
  customFormBuilder,
  setcustomFormBuilder,
  setSectionInfo,
  dropRef,
}) => {
  return (
    <>
      {(media?.images?.length as number) < 5 ? (
        <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={() => handleAddMedia(questionIndex)}>
          <img src={PlusIcon} alt="edit" />
          Add Media
        </Button>
      ) : (
        <Button classes={{ className: `btn ${styles.btn_custom_disable} ${styles.btn_smalls}` }} type="button" disabled>
          <img src={PlusIcon} alt="edit" />
          Add Media
        </Button>
      )}
      {addMedia?.index === questionIndex && (
        <div className={`dropdown-menu show ${styles.media_align}`} ref={dropRef as React.RefObject<HTMLDivElement>}>
          <MultiFileUploadFormBuilder
            handleAddMediaCancel={handleAddMediaCancel}
            questionId={questionId}
            formId={formId}
            mediaList={media}
            questionIndex={questionIndex}
            customFormBuilder={customFormBuilder}
            setcustomFormBuilder={setcustomFormBuilder}
            setSectionInfo={setSectionInfo}
          />
        </div>
      )}
    </>
  );
};
